export { default as ConsumidoresFinalesTab } from "./ConsumidoresFinalesTab";

export { CreacionConsumidorFinal } from "./CreacionConsumidorFinal";
